"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compileCss = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const branding_attachment_styles_1 = __importDefault(require("./branding-attachment.styles"));
const branding_bg_styles_1 = __importDefault(require("./branding-bg.styles"));
const branding_button_styles_1 = __importDefault(require("./branding-button.styles"));
const branding_caption_styles_1 = __importDefault(require("./branding-caption.styles"));
const branding_choice_styles_1 = __importDefault(require("./branding-choice.styles"));
const branding_colors_styles_1 = __importDefault(require("./branding-colors.styles"));
const branding_emotion_styles_1 = __importDefault(require("./branding-emotion.styles"));
const branding_error_styles_1 = __importDefault(require("./branding-error.styles"));
const branding_font_styles_1 = __importDefault(require("./branding-font.styles"));
const branding_footer_styles_1 = __importDefault(require("./branding-footer.styles"));
const branding_input_styles_1 = __importDefault(require("./branding-input.styles"));
const branding_logo_styles_1 = __importDefault(require("./branding-logo.styles"));
const branding_markdown_styles_1 = __importDefault(require("./branding-markdown.styles"));
const branding_question_label_styles_1 = __importDefault(require("./branding-question-label.styles"));
const branding_rating_styles_1 = __importDefault(require("./branding-rating.styles"));
const branding_scale_styles_1 = __importDefault(require("./branding-scale.styles"));
const branding_scroll_styles_1 = __importDefault(require("./branding-scroll.styles"));
const branding_underlay_styles_1 = __importStar(require("./branding-underlay.styles"));
const branding_widget_styles_1 = __importDefault(require("./branding-widget.styles"));
function prepareBrandingConfig({ branding, supportDarkMode }) {
    const prepared = (0, cloneDeep_1.default)(Object.assign(Object.assign({}, branding), { darkTheme: supportDarkMode ? branding.darkTheme : undefined }));
    (0, branding_underlay_styles_1.prepareBrandingForUnderlay)(prepared);
    return prepared;
}
function compileCss(branding = {}, compiler) {
    const lightThemeString = compiler(branding);
    if (branding.darkTheme) {
        const darkThemeString = compiler(branding.darkTheme);
        return (0, react_1.css) `
            :root ${lightThemeString}

            .pythia-surveys-root[data-theme='dark'] ${darkThemeString}
        `;
    }
    return (0, react_1.css) `
        :root ${lightThemeString}
    `;
}
exports.compileCss = compileCss;
function styles(props) {
    const brandingConfig = prepareBrandingConfig(props);
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: (0, branding_footer_styles_1.default)() }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: (0, branding_logo_styles_1.default)() }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: compileCss(brandingConfig, branding_attachment_styles_1.default) }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: compileCss(brandingConfig, branding_bg_styles_1.default) }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: compileCss(brandingConfig, branding_button_styles_1.default) }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: compileCss(brandingConfig, branding_caption_styles_1.default) }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: compileCss(brandingConfig, branding_choice_styles_1.default) }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: compileCss(brandingConfig, branding_colors_styles_1.default) }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: compileCss(brandingConfig, branding_emotion_styles_1.default) }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: compileCss(brandingConfig, branding_error_styles_1.default) }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: compileCss(brandingConfig, branding_font_styles_1.default) }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: compileCss(brandingConfig, branding_input_styles_1.default) }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: compileCss(brandingConfig, branding_markdown_styles_1.default) }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: compileCss(brandingConfig, branding_question_label_styles_1.default) }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: compileCss(brandingConfig, branding_rating_styles_1.default) }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: compileCss(brandingConfig, branding_scale_styles_1.default) }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: compileCss(brandingConfig, branding_scroll_styles_1.default) }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: compileCss(brandingConfig, branding_underlay_styles_1.default) }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: compileCss(brandingConfig, branding_widget_styles_1.default) })] });
}
exports.default = styles;
